import CheckboxGroup, { CheckboxGroupProps } from './checkboxGroup';

export type { CheckboxGroupProps };
export default CheckboxGroup;
